import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['firstSalaryAmount', 'secondSalaryAmount', 'noOfDaysWorked']);
  const createEmployeeCosting = `createEmployeeCosting(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createEmployeeCosting} {
      id
    }
  }
`;
};
